import {
  Container,
  ContainerPadding,
  ReferenceBadge,
  styled,
  Text,
  TokenTextAppearance,
  TokenTextColor,
  WhiteSpace,
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useGetDisclaimer, useIsType6DisclaimersEnabled, transformNumberFormat } from 'src/feature-app/hooks';
import { InfoCuotaProps } from '.';
import { isCommercial } from 'src/bff/get-data-url';
import { getDataServiceConfig } from 'src/feature-app';

const CuotaWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

const TextWitoutMargin = styled.div`
  & div {
    margin: 0px;
  }
`;

const MotorizacionContainer = styled.div`
  & div {
    margin: 0px;
  }

  min-height: 48px;
`;

const FinanciacionWrapper = styled.div`
  padding: 4px 8px;
  background-color: ${(props) => props.color};
  width: fit-content;
  
  & div {
    color: #ffffff;
    margin: 0px;
    line-height: auto;
    width: fit-content;
    font-weight: 600;
  }
`;

export const InfoCuotaHeader = (props: InfoCuotaProps) => {
  const { offer } = props;
  const disclaimer = useGetDisclaimer(offer.legal);
  const isType6DisclaimersEnabled = useIsType6DisclaimersEnabled();
  const [financiacionCopy, setFinanciacionCopy] = useState(null);
  const [financiacionColor, setFinanciacionColor] = useState(null);
  const dataService = getDataServiceConfig();
  const getFinanciacionCopy = (): string => {
    const financiacion = offer.financiacionText;
    const servicio = offer.myWay.activo === 1 && offer.myWay.servicio === 1;
    let copy;

    switch (true) {
      case financiacion === null:
        break;
      case financiacion.includes('Renting'):
        if (!isCommercial(dataService)) {
          copy = 'My Renting con mantenimiento y seguro';
        } else {
          copy = 'My Renting';
        }
        break;
      case financiacion.includes('Ocasión'):
        copy = null;
        break;
      case financiacion.includes('My Way') && servicio:
        copy = 'My Way con mantenimiento y seguro';
        break;
      case financiacion.includes('My Way'):
        copy = 'My Way';
        break;
      default:
        copy = 'NEXT';
    }

    return copy;
  };

  const getFinanciacionColor = (): string => {
    const financiacion = offer.financiacionText;
    const servicio = offer.myWay.activo === 1 && offer.myWay.servicio === 1;
    let color;

    switch (true) {
      case financiacion === null:
        break;
      case financiacion.includes('Renting'):
        color = '#001E50';
        break;
      case financiacion.includes('My Way') && servicio:
        color = '#00B0F0';
        break;
      case financiacion.includes('My Way'):
        color = '#93D5F6';
        break;
      default:
        color = '#FFFFFF';
    }

    return color;
  };

  useEffect(() => {
    const financiacionCopy = getFinanciacionCopy();
    setFinanciacionCopy(financiacionCopy);
    const financiacionColor = getFinanciacionColor();
    setFinanciacionColor(financiacionColor);
  }, [offer]);

  const getTime = (): string => {
    const cuotaTipo = offer.cuotaTipo;
    const tipo = {
      diaria: '/dia',
      mensual: '/mes',
      ninguna: '',
    };
    return tipo[cuotaTipo];
  };

  const isOcasion = (offer: any) => {
    return offer.financiacionText?.includes('Ocasión');
  };

  const transformedCuota = new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(offer.cuota);

  // const transformPrice = (price: number) => new Intl.NumberFormat('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0}).format(price);
  const transformedPrice = new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(offer.precio);

  return (
    <>
      <MotorizacionContainer>
        <Text appearance={TokenTextAppearance.headline200} bold>
          {offer.carlineNuevo === 1 ? 'Nuevo ' : null}
          {offer.carlineTitle} {isOcasion(offer) ? 'de ocasión garantizado' : null} {offer.motorizacion}
        </Text>
      </MotorizacionContainer>

      <Container wrap={'always'} data-testid='info-cuota-header__info-container'>
        {!isOcasion(offer) && (
          <Container wrap={'always'} horizontalAlign={'flex-start'} data-testid='info-cuota-header__info'>
            {isCommercial(dataService) ? (
              <Text appearance={TokenTextAppearance.label150} color={TokenTextColor.secondary}>
                {financiacionCopy}
              </Text>
            ) : (
              <>
                {!offer.precio && (
                  <FinanciacionWrapper color={financiacionColor}>
                    <Text appearance={TokenTextAppearance.label100}>{financiacionCopy}</Text>
                  </FinanciacionWrapper>
                )}
              </>
            )}
            <TextWitoutMargin>
              <Text appearance={TokenTextAppearance.headline200} bold>
                {offer.precio ?
                  <>Desde {transformedPrice}€</>
                  :
                  <>{/* No se renderiza el espacio en la parte de costeTotal después del |, por lo que es necesario usar un ternary aquí */}{transformedCuota}€{getTime()}</>
                }
                {isType6DisclaimersEnabled ? (
                  <Text sup>
                    <ReferenceBadge onClick={() => disclaimer.onClick()}>{disclaimer?.ref}</ReferenceBadge>
                  </Text>
                ) : (
                  <Text sup>{disclaimer?.ref}</Text>
                )}
              </Text>
              {offer.precio &&
                <Text appearance={TokenTextAppearance.copy100} staticSize color={TokenTextColor.secondary}>
                  Sujeto a financiación
                </Text>
              }
            </TextWitoutMargin>
          </Container>
        )}
      </Container>



    </>
  );
};

